const rupaMigration = {
  placeholder: "This is an UNAUTHENTICATED page",
  description: "Welcome to the Rupa Migration",
  button: "Start Migration",
  connect: "Connect",
  next: "Next",
  getHelp: "Get Help",
  letsGetStarted: "Sounds good, let's get started!",
  supportInfo:
    "If you have any questions, please reach out to our Support team at {{supportPhone}} or email {{supportEmail}}",
  welcomeTitle: "Get ready to have everything in one place!",
  welcomeSubtitle: "A few things to know before you get started",
  card: {
    title: "Things to know about the move to Fullscript",
  },
  steps: {
    welcome: "Welcome",
    connectAccounts: "Connect Accounts",
    confirm: "Confirm",
  },
  items: {
    accountInfo: {
      title: "1. Your Rupa account information will be moved to Fullscript",
      details: {
        labs: "All labs you ordered on Rupa are available on Fullscript, with no change in price",
        orderHistory:
          "Your entire order history will be transferred over, even orders that are currently in progress",
        clientList: "Your entire client list will be transferred over",
        favorites: "Your Favorites, Blood Panels, and Bundles will be transferred over",
        snippets: "Your Saved Text Snippets will be transferred over",
      },
    },
    newOrders: {
      title: "2. All new lab orders will be placed on Fullscript",
      details: {
        allNewOrders: "All new lab orders and existing order updates will happen on Fullscript",
        viewOnly:
          "After you complete your move to Fullscript, your Rupa Health account will be in a view-only state",
        inactiveDate: "Your Rupa Health account will be made inactive in February, 2026",
      },
    },
    patients: {
      title: "3. Your patients will move with you",
      details: {
        viewOnly:
          "Your patients Rupa accounts will also be in view-only, and if they log in they'll be prompted to join you on Fullscript",
        unpaidOrders: "Unpaid orders will still be paid for on Rupa",
        newOrders: "Any new orders will be paid for on Fullscript",
        results: "All historical and new results will be available in Fullscript",
      },
    },
  },
  emailLabel: "Email",
  passwordLabel: "Password",
  requiredIndicator: "*",
  createAccountButton: "Create account",
  patient: {
    joinHeading: "Join {{practitionerFullName}} on Fullscript",
    joinSubheading: "Your practitioner now uses Fullscript to manage labs. Create an account to:",
    benefit1: "View all your past lab results from Rupa",
    benefit2: "Purchase and manage new lab orders",
    benefit3: "Purchase high-quality supplements",
    passwordHeading: "Set a password for your new account",
  },
  termsText: "I agree to Fullscript's <1>Terms of Service</1> and <2>Privacy policy</2>.",
  clerk: {
    joinHeading: "Get excited, {{name}}!",
    joinSubheading: "On Fullscript, you will be able to:",
    benefit1: "Order all of your labs and supplements from Fullscript",
    benefit2: "Get access to more blood lab options, including Quest!",
    benefit3: "Build and re-use plans for common treatments",
    benefit4: "Much more to come!",
    passwordHeading: "Create your new Fullscript account",
    alreadyHaveAccount: "Already have an account? <1>Sign in</1>",
  },
  onboarding: {
    signDocuments: {
      success: "Documents signed successfully",
    },
  },
} as const;

export { rupaMigration };
